import React, { useEffect, useState } from "react";
import PrivateApi from "../../../services/PrivateApiService";
import { Button, Card, Col, Form, ListGroup, Row, Spinner } from "react-bootstrap";
import NotificationListItem from "./NotificationListItem";
import { FaBookReader } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { useQuery } from "react-query";
import EnergoPagination from "../EnergoPagination";
import { useAuthState } from "../../../context/AuthContext";

/**
 * NotificationList
 * 
 * This list is used in NotificationPage to display 
 * user notifications.
 * 
 * used in: NotificationPage
 * 
 * @returns HTML List
 */
const NotificationList = () => {

    const API = new PrivateApi(); // API
    const { user } = useAuthState();
    const [selectedList, setSelectedList] = useState([]); // array of ids which has been checked with checkbox

    // pagination
    const [maxItemsInPagination, setMaxItemsInPagination] = useState(5);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentView, setCurrentView] = useState([]);

    // collect notification
    const { data, error, isLoading, refetch } = useQuery("GET_USER_NOTIFICATION_QUERY", API.get_Notifications, {staleTime: Infinity});

    
    // pagination effects
    useEffect(() => {
        if (data !== undefined) {
            setCurrentView(data.slice(0, maxItemsInPagination));
        }
    }, [data])
    
    useEffect(() => {
        if (data !== undefined) {
            var start = (currentPage -1) * maxItemsInPagination ;
            var end = currentPage * maxItemsInPagination;
            setCurrentView(data.slice(start, end));
        }
    }, [currentPage, maxItemsInPagination])



    // checkbox has beed checked add to selectedList
    const addToSelected = (notificationId) => {
        var tempList = [...selectedList];
        tempList.push(notificationId);
        setSelectedList(tempList);
    }

    // checkbox has been unchecked remove from selectedList
    const removeFromSelected = (notificationId) => {
        var tempList = [...selectedList];
        tempList.pop(notificationId);
        setSelectedList(tempList);
    }

    // send selectedList to backend to delete notifications for this user
    const deleteNotifications = () => {
        if (selectedList.length > 0) {
            API.delete_Notifications(selectedList);
            refetch();
        }
    }
    
    // send selectedList to backend to mark them as readed for this user
    const markAsRead = () => {
        if (selectedList.length > 0) {
            API.setRead_Notifications(selectedList);
            selectedList.forEach(id => {
                document.getElementById(`check-${id}`).checked = false;
            })
            setSelectedList([]);
            refetch();
        }
    }

    // if data collecting is still loading
    if (isLoading) return <Spinner animation="border" className="text-energo" /> ;

    // if data collecting produced error
    if (error) return <p className="text-danger">Es ist ein Fehler aufgetreten. Versuche es später erneut.</p>

    // if loading is done and data is empty
    if (!isLoading && data !== undefined && data.length === 0) return <p className="text-energo">Sie haben keine Benachrichtigungen</p>

    // GUI
    return (
        <>
            <Row className="mb-2">
                <Col xs="10" className="text-start">
                    <Button 
                        hidden
                        onClick={() => deleteNotifications()} 
                        className="btn-danger btn-sm rounded-pill" 
                        style={{marginRight: "5px"}}
                    >
                        <MdDelete size={15}/>&nbsp; löschen
                    </Button>
                    <Button 
                        hidden={selectedList.length === 0 || user.x_is_house_management}
                        onClick={() => markAsRead()} 
                        className="btn-energo btn-sm rounded-pill"
                    >
                        <FaBookReader size={15} />&nbsp; als gelesen markieren
                    </Button>
                </Col>
                <Col xl="2" className="text-end">
                    <div className="d-inline-block" style={{marginRight: "5px"}}>
                        <Form.Select defaultValue={maxItemsInPagination} onChange={e => setMaxItemsInPagination(e.target.value)}>
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                            <option value={500}>500</option>
                        </Form.Select>
                    </div>
                    pro Seite
                </Col>
            </Row>
            <Card style={{borderRadius: "15px", borderLeft: "3px solid #a2c13f", borderBottom: "3px solid #a2c13f"}}>
                <Card.Body style={{padding: "10px 2px 15px 2px"}}>
                    <ListGroup variant="flush">
                        {currentView.map(not => (
                            <NotificationListItem key={not.id} notification={not} addToSelected={addToSelected} removeFromSelected={removeFromSelected} />   
                        ))}
                    </ListGroup>
                    {
                        currentView.length > maxItemsInPagination ?
                            <div className="text-center" style={{marginTop: "30px"}} >
                                <EnergoPagination max={Math.ceil(data.length / maxItemsInPagination)} current={currentPage} select={setCurrentPage} />
                            </div>
                        :null
                    }
                </Card.Body>
            </Card>
        </>
    )
}
export default NotificationList;